import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import {ShoppingFilterPipe} from '@app/core/pipe/shopping.filter.pipe';
import {FormsModule} from '@angular/forms';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ChainService} from '@app/chain/chain.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    HomeRoutingModule,
    FormsModule
  ],
  declarations: [
    HomeComponent,
    ShoppingFilterPipe
  ],
  providers: [
    ShoppingService,
    ChainService
  ]

})
export class HomeModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/home/home.module.ts